import React from 'react';
import Icon from '@atlaskit/icon';
import { injectIntl } from '@atlassian/jira-intl';
import { Tooltip } from '@atlassian/jira-portfolio-3-common';
import jiraIcon from '@atlassian/jira-portfolio-3-portfolio/src/common/icons/jira-logo.raw.svg';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

function Title({ plan }: { plan: Props['plan'] }) {
	if (!plan) {
		return null;
	}

	return (
		<Tooltip content={plan.title || ''}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.planTitle}>{plan.title || ''}</div>
		</Tooltip>
	);
}

function Scenario({ scenario }: { scenario: Props['scenario'] }) {
	if (!scenario) {
		return null;
	}

	return (
		<Tooltip content={scenario.title}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.scenario}>
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.scenarioColor} style={{ backgroundColor: scenario.color }} />
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.scenarioTitle}>{scenario.title}</div>
			</div>
		</Tooltip>
	);
}

function Header({ plan, scenario }: Props) {
	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div className={styles.root}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.titleBar}>
				<Title plan={plan} />
				<Scenario scenario={scenario} />
			</div>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.logoContainer}>
				<Icon label="" dangerouslySetGlyph={jiraIcon} />
			</div>
		</div>
	);
}

export default injectIntl(Header);
